import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  template: `<h1>Unauthorized</h1>
    <p>Non hai i permessi per visualizzare questa pagina.</p>`,
})
export class UnauthorizedComponent {}
